import { styled } from "@pigment-css/react";
import React from "react";

interface SidePanelSectionProps {
  title?: string;
  children: React.ReactNode;
}

const Section = styled("section")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.managementView.spacing[16],
}));

const SectionTitle = styled("h3")(({ theme }) => ({
  fontFamily: theme.managementView.font.family,
  fontSize: theme.managementView.font.size[16],
  fontWeight: theme.managementView.font.weight[400],
  color: theme.managementView.colors.neutral[100],
  margin: 0,
}));

export const SidePanelSection = ({ title, children }: SidePanelSectionProps) => {
  return (
    <Section>
      {title && <SectionTitle>{title}</SectionTitle>}
      {children}
    </Section>
  );
};
